// @flow
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router-dom';
import ArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import { getRadioUser } from '../../authentication/session/selectors/sessionSelectors';
import { closeSession } from '../../authentication/session/actions/sessionActions';
import RadioUser from '../../../domain/RadioUser';

type Props = {
  theme: any,
  user: RadioUser,
  t: any,
  isAuthenticated: boolean;
  actions: {
    closeSession: () => mixed;
  }
}

type State = {
  open: boolean,
  anchorEl: ?any,
};

class ProfileDropDown extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: undefined,
    };
  }

  handleClick = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  logout = () => {
    this.setState({ open: false });
    this.props.actions.closeSession();
  }

  render() {
    const {
      theme, user, t, isAuthenticated,
    } = this.props;
    if (!isAuthenticated || user === undefined) {
      return null;
    }
    return (
      <div>
        <FlatButton
          onClick={this.handleClick}
          label={user ? user.getName() : t('actions')}
          labelPosition="before"
          labelStyle={{ color: theme.colors.tertiaryText }}
          icon={<ArrowDown style={{ fill: theme.colors.tertiaryText }} />}
        />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>
            {user && <MenuItem onClick={this.handleRequestClose} containerElement={<Link to="/user-profile" />} value={1} primaryText={t('profileMenuItem')} />}
            <MenuItem onClick={this.logout} value={2} primaryText={t('signOut')} />
          </Menu>
        </Popover>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getRadioUser(state),
    isAuthenticated: state.session.isAuthenticated,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ closeSession }, dispatch),
  };
}

export default translate('userProfile')(connect(mapStateToProps, mapDispatchToProps)(withTheme(ProfileDropDown)));



// WEBPACK FOOTER //
// ./src/statsradio/modules/userProfile/components/ProfileDropDown.js